import styled from 'styled-components';
import { getThemeProp } from 'theme';

const Separator = styled.div`
  height: 1px;
  margin: 6px 0;
  width: 100%;
  background-color: ${getThemeProp('colors.athensGrey')};
`;

export default Separator;
